import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaArrowRight, 
  FaStar, 
  FaHeart, 
  FaShoppingBag, 
  FaEye,
  FaBed,
  FaFilter,
  FaSearch
} from 'react-icons/fa';

const Bedroom = () => {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const products = [
    {
      id: 1,
      name: 'King Size Bed',
      image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '28% OFF',
      rating: 4.9,
      category: 'bed',
      description: 'Wooden king size bed with storage'
    },
    {
      id: 2,
      name: 'Queen Size Bed',
      image: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '26% OFF',
      rating: 4.8,
      category: 'bed',
      description: 'Elegant queen size bed with headboard'
    },
    {
      id: 3,
      name: 'Wardrobe 3 Door',
      image: 'https://www.ikea.com/pt/en/images/products/brimnes-wardrobe-with-3-doors-white__0858640_pe655296_s5.jpg?f=xl',
      discount: '29% OFF',
      rating: 4.7,
      category: 'wardrobe',
      description: '3-door wooden wardrobe with mirror'
    },
    {
      id: 4,
      name: 'Dressing Table',
      image: 'https://woodenbazar.com/cdn/shop/files/wooden-bazar-flutura-vanity-dressing-table-with-mirror-modern-designs-for-bedroom-white-369_1000x.webp?v=1729369604',
      discount: '32% OFF',
      rating: 4.6,
      category: 'dressing',
      description: 'Modern dressing table with mirror'
    },
    {
      id: 5,
      name: 'Night Stand',
      image: 'https://i5.walmartimages.com/asr/c0196719-43a1-4856-b111-1585b87e624a.c21e16ac3acfafba6a906b74ee0ccbaf.jpeg',
      discount: '37% OFF',
      rating: 4.5,
      category: 'nightstand',
      description: 'Wooden night stand with drawer'
    },
    {
      id: 6,
      name: 'Orthopedic Mattress',
      image: 'https://5.imimg.com/data5/SELLER/Default/2024/11/468080257/GZ/AO/KM/16001243/wakefit-ortho-plus-mattress-1000x1000.jpg',
      discount: '36% OFF',
      rating: 4.9,
      category: 'mattress',
      description: 'Orthopedic mattress for back pain relief'
    },
    {
      id: 7,
      name: 'Cotton Bedsheet Set',
      image: 'https://th.bing.com/th/id/R.0a348fcfe46078bd75473cec9abe2450?rik=OH4CJEaCXHrv6g&riu=http%3a%2f%2fcdn.shopify.com%2fs%2ffiles%2f1%2f0549%2f2532%2f8602%2fproducts%2f1_f4eb8e98-93f2-4c88-ab79-9537a727b8b1.jpg%3fv%3d1656052002&ehk=AlzOFG90qU6FnvmHIkB%2fRp0xWtjd4E0TysigjdEjGfk%3d&risl=&pid=ImgRaw&r=0',
      discount: '50% OFF',
      rating: 4.8,
      category: 'bedding',
      description: 'Soft cotton bedsheet with 4 pillow covers'
    },
    {
      id: 8,
      name: 'Memory Foam Pillow',
      image: 'https://tse2.mm.bing.net/th/id/OIP.CwzygZCcK2kl57kvaMoJ2gHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
      discount: '48% OFF',
      rating: 4.7,
      category: 'bedding',
      description: 'Ergonomic memory foam pillow'
    },
    {
      id: 9,
      name: 'Wardrobe 4 Door',
      image: 'https://stylesatlife.com/wp-content/uploads/2019/06/Wenge-4-Door-Wardrobe.jpg',
      discount: '28% OFF',
      rating: 4.8,
      category: 'wardrobe',
      description: 'Spacious 4-door wardrobe with drawers'
    },
    {
      id: 10,
      name: 'Bedside Lamp',
      image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '43% OFF',
      rating: 4.4,
      category: 'lighting',
      description: 'Modern bedside table lamp'
    },
    {
      id: 11,
      name: 'Quilt/Comforter',
      image: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '40% OFF',
      rating: 4.6,
      category: 'bedding',
      description: 'Warm quilt for winter'
    },
    {
      id: 12,
      name: 'Wall Shelf',
      image: 'https://images.unsplash.com/photo-1597072689227-8882273e8f6a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '33% OFF',
      rating: 4.5,
      category: 'storage',
      description: 'Floating wall shelf for bedroom'
    }
  ];

  const filters = [
    { id: 'all', name: 'All Products' },
    { id: 'bed', name: 'Beds' },
    { id: 'wardrobe', name: 'Wardrobes' },
    { id: 'mattress', name: 'Mattresses' },
    { id: 'bedding', name: 'Bedding' },
    { id: 'lighting', name: 'Lighting' }
  ];

  const filteredProducts = products.filter(product => {
    const matchesFilter = selectedFilter === 'all' || product.category === selectedFilter;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative h-64 bg-gradient-to-r from-purple-500 to-pink-500 overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute inset-0 flex items-center justify-center text-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Bedroom Collection
            </h1>
            <p className="text-lg text-white/90 max-w-2xl mx-auto px-4">
              Create your peaceful sanctuary with our bedroom furniture
            </p>
          </div>
        </div>
      </div>

      {/* Filters Section */}
      <div className="container mx-auto px-4 py-8">
        {/* Search Bar */}
        <div className="max-w-md mx-auto mb-8">
          <div className="relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:border-pink-500 focus:ring-2 focus:ring-pink-200 transition-all duration-300"
            />
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setSelectedFilter(filter.id)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                selectedFilter === filter.id
                  ? 'bg-gradient-to-r from-pink-500 to-blue-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-600 hover:text-pink-500 shadow hover:shadow-md'
              }`}
            >
              {filter.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredProducts.map((product) => (
            <div key={product.id} className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden">
              {/* Discount Badge */}
              <div className="absolute top-4 left-4 z-10 bg-gradient-to-r from-pink-500 to-blue-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                {product.discount}
              </div>

              {/* Image Container */}
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-3">
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-pink-500 hover:bg-pink-500 hover:text-white transition-all duration-300">
                    <FaShoppingBag size={16} />
                  </button>
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-blue-500 hover:bg-blue-500 hover:text-white transition-all duration-300">
                    <FaHeart size={16} />
                  </button>
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-purple-500 hover:bg-purple-500 hover:text-white transition-all duration-300">
                    <FaEye size={16} />
                  </button>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-5">
                <h3 className="text-base font-semibold text-gray-800 mb-1 group-hover:text-pink-500 transition-colors duration-300">
                  {product.name}
                </h3>
                <p className="text-xs text-gray-500 mb-2 line-clamp-1">{product.description}</p>
                
                {/* Rating */}
                <div className="flex items-center gap-1 mb-3">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className={`text-xs ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'}`} />
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">({product.rating})</span>
                </div>

                {/* Price */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-bold text-gray-800">{product.price}</span>
                    <span className="text-xs text-gray-400 line-through">{product.oldPrice}</span>
                  </div>
                </div>

                {/* Add to Cart Button */}
                <button className="w-full py-2.5 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-lg text-sm font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300">
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* No Results Message */}
        {filteredProducts.length === 0 && (
          <div className="text-center py-16">
            <p className="text-xl text-gray-500">No products found matching your criteria.</p>
          </div>
        )}

        {/* Load More Button */}
        {filteredProducts.length > 0 && (
          <div className="text-center mt-12">
            <button className="px-8 py-3 bg-white text-pink-500 rounded-full font-semibold shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 border-2 border-pink-500 hover:bg-pink-500 hover:text-white">
              Load More Products
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Bedroom;